import { AnyAxiosInterceptor } from "api/core/consts";

export const any = {
  firstLogin: (token, body) => AnyAxiosInterceptor.put('/firstLogin', body, { headers: { Authorization: token } }),
  getMyData: (token) => AnyAxiosInterceptor.get('/oneSelf', { headers: { Authorization: token } }),
  updateMyData: (token, body) => AnyAxiosInterceptor.put('/oneSelf', body, { headers: { Authorization: token } }),
  deleteMyData: (token) => AnyAxiosInterceptor.delete('/oneSelf', { headers: { Authorization: token } }),
};
